import { MOVING_AGENT_COMPANY_PROFILE_ID } from "../constants";
import { StorageBox } from "../models/storage.box";
import { User } from "../models/user";

/**
 * Maps military / reweigh API fields to the flat shape used by ViewMode and forms;
 * filters storage boxes like Maintenance onSuccess.
 */
export function normalizeOrderWebPayload(payload: any, currentUser?: User | null) {
  const isMilitaryCompany = Boolean(
    payload?.company?.isMilitary ?? currentUser?.company?.isMilitary
  );
  const first = payload?.preApprovals?.[0];

  const preApprovalsFlat =
    isMilitaryCompany && first != null
      ? {
          preApprovalsGoShareId: first.goShareId ?? "",
          preApprovalsCode: first.code ?? "",
          preApprovalsDescription: first.description ?? "",
          preApprovalsCount:
            first.count !== undefined && first.count !== null ? String(first.count) : "",
          preApprovalsUnit: first.unit ?? "",
          preApprovalsCurrency: first.currency ?? "",
          preApprovalsRate:
            first.rate !== undefined && first.rate !== null ? String(first.rate) : "",
          preApprovalsTotal:
            first.total !== undefined && first.total !== null ? String(first.total) : "",
        }
      : {};

  const militaryReweighAndRelatedFlat = isMilitaryCompany
    ? {
        grossWeight:
          payload.reweighGrossWeight !== undefined && payload.reweighGrossWeight !== null
            ? payload.reweighGrossWeight
            : "",
        tareWeight:
          payload.reweighTareWeight !== undefined && payload.reweighTareWeight !== null
            ? payload.reweighTareWeight
            : "",
        netWeight:
          payload.reweighNetWeight !== undefined && payload.reweighNetWeight !== null
            ? payload.reweighNetWeight
            : "",
        grade: payload.grade ?? "",
        sitInDate: payload.sitInDate ?? "",
        sitOutDate: payload.sitOutDate ?? "",
        sitNumber: payload.sitNumber ?? "",
        scacCode: payload.scacCode ?? "",
        scacDescription: payload.scacDescription ?? "",
        scacPhone: payload.scacPhone ?? "",
        scacEmail: payload.scacEmail ?? "",
        scacClaimsPhone: payload.scacClaimsPhone ?? "",
        scacClaimsEmail: payload.scacClaimsEmail ?? "",
      }
    : {};

  const militaryFlat = { ...militaryReweighAndRelatedFlat, ...preApprovalsFlat };

  return {
    ...payload,
    ...militaryFlat,
    storageBoxes: [
      ...(payload.storageBoxes?.filter((sb: StorageBox) => sb.valid && sb.isActive) || []),
    ],
  };
}
